export type WidgetRect = { x: number; y: number; w: number; h: number };

export function rectsOverlap(a: WidgetRect, b: WidgetRect): boolean {
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

export function checkCollision(layout: Array<Partial<WidgetRect> | null | undefined>, x: number, y: number, w: number, h: number): boolean {
  const candidate: WidgetRect = { x, y, w, h };

  for (const item of layout) {
    if (!item) continue;
    const wx = item.x ?? 0;
    const wy = item.y ?? 0;
    const ww = item.w ?? 1;
    const wh = item.h ?? 1;
    if (rectsOverlap(candidate, { x: wx, y: wy, w: ww, h: wh })) return true;
  }

  return false;
}

export function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n));
}

export function findNearestPlacement(params: {
  desiredX: number;
  desiredY: number;
  w: number;
  h: number;
  columns: number;
  searchRadiusCells: number;
  collides: (x: number, y: number, w: number, h: number) => boolean;
}): { x: number; y: number } | null {
  const { desiredX, desiredY, w, h, columns, searchRadiusCells, collides } = params;
  const maxX = Math.max(0, columns - w);

  const baseX = clamp(Math.round(desiredX), 0, maxX);
  const baseY = Math.max(0, Math.round(desiredY));

  let best: { x: number; y: number; dist2: number } | null = null;
  for (let dy = -searchRadiusCells; dy <= searchRadiusCells; dy++) {
    for (let dx = -searchRadiusCells; dx <= searchRadiusCells; dx++) {
      const x = clamp(baseX + dx, 0, maxX);
      const y = Math.max(0, baseY + dy);
      if (collides(x, y, w, h)) continue;
      const dist2 = dx * dx + dy * dy;
      if (!best || dist2 < best.dist2) best = { x, y, dist2 };
    }
  }

  return best ? { x: best.x, y: best.y } : null;
}

export function isWithinStickyRect(
  pointer: { x: number; y: number } | null | undefined,
  rect: { left: number; right: number; top: number; bottom: number } | null | undefined,
  stickyPx: number
): boolean {
  if (!pointer || !rect) return false;
  return (
    pointer.x >= rect.left - stickyPx && pointer.x <= rect.right + stickyPx && pointer.y >= rect.top - stickyPx && pointer.y <= rect.bottom + stickyPx
  );
}
